import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLastBiddingCalculatedTotalsReleaseDate } from '../../hooks/api/biddingCalculated';
import { useLastCorrectedTotalsUploadDate } from '../../hooks/api/correctedTotals';

const LastTotalsReleaseDate = ({
    text,
    workingUnitLocation,
    showCorrectedTotalsUploadDateIfPresent = false,
}: {
    text?: string;
    workingUnitLocation: number;
    showCorrectedTotalsUploadDateIfPresent?: boolean;
}) => {
    const { t } = useTranslation();
    const lastBiddingCalculatedTotalsReleaseDate = useLastBiddingCalculatedTotalsReleaseDate(workingUnitLocation);
    const lastCorrectedTotalsUploadDate = useLastCorrectedTotalsUploadDate(workingUnitLocation);

    const date = showCorrectedTotalsUploadDateIfPresent
        ? lastCorrectedTotalsUploadDate
        : lastBiddingCalculatedTotalsReleaseDate;

    const displayedText = text
        ? text
        : showCorrectedTotalsUploadDateIfPresent && lastCorrectedTotalsUploadDate
          ? t('field.lastUpload')
          : t('field.lastChange');

    return (
        <Typography>
            {displayedText}: <span style={{ display: 'block' }}>{date}</span>
        </Typography>
    );
};

export default LastTotalsReleaseDate;
